
export default {
  computed: {
    logined () {
      return this.$store.state.Session.logined
    }
  },
  methods: {
    checkLogin () {
      if (!this.logined) {
        this.$router.push({ path: '/' })
      }
    },
    checkService (response) {
      if (response.error.startsWith('503')) {
        this.$root.$bvToast.toast('現在メンテナンス中です！', {
          autoHideDelay: 5000,
          appendToast: true
        })
        this.$router.push({ path: '/' })
      } else {
        this.setData(response)
      }
    }
  }
}
